import type { TrackContributionPayload } from './types/index.js';

export function trackContributionPolylinePointCount(payload: TrackContributionPayload) {
  return payload.polylinePointCount ?? payload.gpsPolyline.length;
}

export function trackContributionCornerCount(payload: TrackContributionPayload) {
  return payload.cornerCount ?? payload.cornerApexSuggestions.length;
}

export function trackContributionHasGeometry(payload: TrackContributionPayload) {
  return trackContributionPolylinePointCount(payload) >= 2;
}
